import { Link } from "react-router-dom";
import { RiArrowRightLine, RiExternalLinkLine } from "react-icons/ri";
import { PROFILE } from "../../Data/siteData";

const TECH_STACK = [
    { label: ".NET Core",   accent: true  },
    { label: "ASP.NET",     accent: true  },
    { label: "C#",          accent: true  },
    { label: "React.js",    accent: false },
    { label: "SQL Server",  accent: true  },
    { label: "JavaScript",  accent: false },
    { label: "Python",      accent: false },
    { label: "Node.js",     accent: false },
    { label: "React Native",accent: false },
    { label: "Figma",       accent: false },
];

const STATS = [
    { value: PROFILE.yearsOfExperience, label: "Years Exp." },
    { value: "20+",  label: "Projects Built"   },
    { value: "10+",  label: "Systems in Prod." },
    { value: "AU",   label: "Based · Remote"   },
];

const Home = () => {
    return (
        <div className="py-2">
            <style>{`
                @keyframes heroFadeUp {
                    from { opacity: 0; transform: translateY(18px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                .h1 { animation: heroFadeUp 0.5s ease both 0.00s; }
                .h2 { animation: heroFadeUp 0.5s ease both 0.08s; }
                .h3 { animation: heroFadeUp 0.5s ease both 0.16s; }
                .h4 { animation: heroFadeUp 0.5s ease both 0.24s; }
                .h5 { animation: heroFadeUp 0.5s ease both 0.32s; }
                .h6 { animation: heroFadeUp 0.5s ease both 0.42s; }

                @keyframes availablePulse {
                    0%, 100% { opacity: 1; }
                    50%      { opacity: 0.4; }
                }
                .available-dot {
                    display: inline-block;
                    width: 7px;
                    height: 7px;
                    border-radius: 50%;
                    background: #22c55e;
                    animation: availablePulse 2s ease-in-out infinite;
                    flex-shrink: 0;
                }

                .btn-primary {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 10px 20px;
                    border-radius: 8px;
                    font-size: 13px;
                    font-weight: 500;
                    letter-spacing: 0.02em;
                    text-decoration: none;
                    background: rgba(200, 151, 42, 0.12);
                    border: 1px solid rgba(200, 151, 42, 0.45);
                    color: #C8972A;
                    transition: all 0.18s ease;
                }
                .btn-primary:hover {
                    background: rgba(200, 151, 42, 0.22);
                    border-color: rgba(200, 151, 42, 0.8);
                    color: #F0C060;
                }

                .btn-secondary {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 10px 20px;
                    border-radius: 8px;
                    font-size: 13px;
                    font-weight: 400;
                    letter-spacing: 0.02em;
                    text-decoration: none;
                    background: rgba(255, 255, 255, 0.05);
                    border: 1px solid rgba(255, 255, 255, 0.13);
                    color: rgba(255, 255, 255, 0.65);
                    transition: all 0.18s ease;
                }
                .btn-secondary:hover {
                    background: rgba(255, 255, 255, 0.09);
                    border-color: rgba(255, 255, 255, 0.28);
                    color: #fff;
                }

                .stat-card {
                    padding: 14px 12px;
                    background: rgba(255, 255, 255, 0.04);
                    border: 1px solid rgba(255, 255, 255, 0.07);
                    border-radius: 10px;
                    text-align: center;
                    transition: border-color 0.18s ease;
                }
                .stat-card:hover {
                    border-color: rgba(200, 151, 42, 0.2);
                }

                .tech-badge {
                    display: inline-block;
                    padding: 4px 11px;
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 500;
                    letter-spacing: 0.02em;
                    transition: all 0.15s ease;
                }
                .tech-badge-accent {
                    background: rgba(200, 151, 42, 0.1);
                    border: 1px solid rgba(200, 151, 42, 0.28);
                    color: #C8972A;
                }
                .tech-badge-accent:hover { background: rgba(200, 151, 42, 0.18); }
                .tech-badge-default {
                    background: rgba(255, 255, 255, 0.05);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    color: rgba(255, 255, 255, 0.6);
                }
                .tech-badge-default:hover { background: rgba(255, 255, 255, 0.09); }
            `}</style>

            {/* Available badge */}
            <div className="h1 flex items-center gap-2 mb-5">
                <span className="available-dot" />
                <span style={{
                    fontSize: "10px",
                    color: "rgba(34, 197, 94, 0.8)",
                    letterSpacing: "0.22em",
                    textTransform: "uppercase",
                    fontWeight: 500,
                }}>
                    Available · Open to Opportunities
                </span>
            </div>

            {/* Main headline */}
            <h1 className="h2 text-3xl lg:text-4xl font-bold text-white leading-tight mb-2">
                Full-Stack Engineer
            </h1>
            <h2 className="h3 text-xl lg:text-2xl font-semibold mb-5" style={{ color: "#C8972A" }}>
                .NET &amp; React Specialist
            </h2>

            {/* Description */}
            <p
                className="h4 text-gray-400 leading-relaxed mb-3"
                style={{ fontSize: "14px", maxWidth: "500px" }}
            >
                Building scalable backend systems &amp; data-driven applications.
                Currently shipping production systems at{" "}
                <span className="text-white font-medium">Cora Group (AU)</span>.
            </p>
            <p
                className="h4 text-gray-500 leading-relaxed mb-7"
                style={{ fontSize: "13px", maxWidth: "500px", fontStyle: "italic" }}
            >
                I design and ship systems that hold up in production.
            </p>

            {/* CTA buttons */}
            <div className="h4 flex flex-wrap items-center gap-3 mb-9">
                <Link to="/projects" className="btn-primary">
                    View Projects <RiArrowRightLine size={15} />
                </Link>
                <a
                    href="https://www.linkedin.com/in/natanael-geraldo-sulaiman-952a561a9"
                    target="_blank"
                    rel="noreferrer"
                    className="btn-secondary"
                >
                    LinkedIn <RiExternalLinkLine size={13} />
                </a>
            </div>

            {/* Divider */}
            <div
                className="h5 mb-5"
                style={{ height: "1px", background: "rgba(255,255,255,0.07)" }}
            />

            {/* Stats */}
            <div className="h5 grid grid-cols-2 sm:grid-cols-4 gap-3 mb-8">
                {STATS.map((stat) => (
                    <div className="stat-card" key={stat.label}>
                        <div
                            className="text-xl font-bold mb-1"
                            style={{ color: "#C8972A" }}
                        >
                            {stat.value}
                        </div>
                        <div
                            className="text-gray-500"
                            style={{
                                fontSize: "10px",
                                letterSpacing: "0.06em",
                                textTransform: "uppercase",
                            }}
                        >
                            {stat.label}
                        </div>
                    </div>
                ))}
            </div>

            {/* Tech Stack */}
            <div className="h6">
                <div
                    className="mb-3 text-gray-500"
                    style={{
                        fontSize: "10px",
                        letterSpacing: "0.25em",
                        textTransform: "uppercase",
                        fontWeight: 500,
                    }}
                >
                    Core Tech Stack
                </div>
                <div className="flex flex-wrap gap-2">
                    {TECH_STACK.map((tech) => (
                        <span
                            key={tech.label}
                            className={`tech-badge ${
                                tech.accent
                                    ? "tech-badge-accent"
                                    : "tech-badge-default"
                            }`}
                        >
                            {tech.label}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Home;
